import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import Button from '@mui/material/Button';

const CardFooter = ({ id, children, errorMessage, success, onActionClick, disabled }) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    sx={{
      px: 3,
      py: 1,
      borderRadius: 5,
      minHeight: 60,
      backgroundColor: { sx: 'white', md: 'gray.A100' },
    }}
  >
    {success ? (
      children
    ) : (
      <Typography variant="small_2" color="warning.A700" fontWeight={600}>
        {errorMessage}
      </Typography>
    )}
    {onActionClick && (
      <Button
        id={`${id}-action-button`}
        startIcon={<UploadFileOutlinedIcon />}
        onClick={onActionClick}
        variant="contained"
        size="small"
        disabled={disabled}
      >
        <Typography variant="small_2" fontWeight={700}>
          Subir
        </Typography>
      </Button>
    )}
  </Stack>
);

CardFooter.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  errorMessage: PropTypes.string.isRequired,
  success: PropTypes.bool.isRequired,
  onActionClick: PropTypes.func,
  disabled: PropTypes.bool,
};

CardFooter.defaultProps = {
  onActionClick: null,
  disabled: false,
};

export default CardFooter;
